import { Reveal, SectionHeader } from "../site/Reveal";

export default function FaqList({ faqs, testId = "faq-list" }) {
  return (
    <section data-testid={testId} className="py-24 lg:py-32 bg-cream border-t border-navy/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-[0.8fr_1.2fr] gap-14">
        <SectionHeader overline="Good to Know" title={<>Questions brands <em className="italic font-medium">ask us.</em></>} />
        <dl className="divide-y divide-navy/10">
          {faqs.map(({ q, a }, i) => (
            <Reveal key={q} delay={i * 0.05}>
              <div className="py-7">
                <dt className="font-display text-xl text-navy">{q}</dt>
                <dd className="mt-3 text-sm leading-relaxed text-charcoal/75 max-w-2xl">{a}</dd>
              </div>
            </Reveal>
          ))}
        </dl>
      </div>
    </section>
  );
}
